import { capfirst } from 'journalize';

const PARTY_SORT_ORDER = [
  'democrat',
  'republican',
  'libertarian',
  'independent',
  'write-in',
];

export function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

export function determineDistrictTitle(contest) {
  return `${contest.office} - ${capfirst(contest.division_type)} ${
    contest.division_type === 'statewide' ? '' : contest.district
  }`.trim();
}

export function determineContestTitle(contest) {
  if (contest.division_type === 'statewide') return 'Statewide';

  return determineDistrictTitle(contest);
}

export function determineBallotTitle(contest) {
  var office = contest.values[0].values[0].office;
  var label = contest.values[0].values[0].label;
  var district = contest.values[0].values[0].district;

  return `${office} ${capfirst(label)} ${
    label === 'statewide' ? '' : district
  }`.trim();
}

export function changePartyName(contest) {
  var name = contest == 'Democratic' ? 'Democrat' : 'Republican';
  return name;
}
  